module.exports = __webpack_public_path__ + "3c6d0ee69dfe9a033021ed3c468bc456.png";